var _circle, _g, _g2, _g3, _g4, _g5, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPearl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.8032,
    r: 12,
    fill: "#DBC7BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2182_51293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4598 11.3138C22.4598 11.3138 22.4598 14.0427 13.0291 14.0427C5.84072 14.0427 4.14718 12.0741 3.80005 11.4809C3.73743 11.3739 3.71838 11.2511 3.722 11.1272C3.83672 7.19658 7.55419 2.79834 13.0291 2.79834C18.5908 2.79834 22.4598 7.33716 22.4598 11.3138Z",
    fill: "#AFADB2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2182_51293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60012 16.6934C2.10261 15.722 3.14203 14.96 4.1048 15.4739C11.4128 19.3751 17.8107 17.9112 24.5506 13.5629C24.5506 13.5629 22.7068 22.6296 12.9133 22.6296C6.78762 22.6296 3.90219 19.2356 2.60012 16.6934Z",
    fill: "#ECE6D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2182_51293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72366 18.7883C4.47647 23.6102 16.9451 26.853 22.7337 19.5742C22.7337 19.5742 19.3142 25.0756 12.5171 24.743C5.72003 24.4104 2.72366 18.7883 2.72366 18.7883Z",
    fill: "#CA9D97",
    fillOpacity: 0.12
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2182_51293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1114 12.3908C17.1477 12.8636 16.872 13.3036 16.4259 13.4643C14.1337 14.2902 11.0235 14.2674 9.04044 13.1656C9.04044 13.1656 10.0643 6.84894 12.9252 6.84894C15.5413 6.84894 16.8983 9.62139 17.1114 12.3908Z",
    fill: "#82837D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2182_51293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0291 2.88064C18.5468 2.88064 22.3775 7.38405 22.3775 11.3138L22.3774 11.317C22.3772 11.3206 22.3767 11.3267 22.3758 11.335C22.3738 11.3517 22.3698 11.3776 22.3615 11.4113C22.3449 11.4788 22.3108 11.5781 22.2412 11.6991C22.1021 11.9406 21.8186 12.272 21.2398 12.607C20.0796 13.2784 17.7392 13.9604 13.0291 13.9604C5.85207 13.9604 4.19623 11.995 3.87108 11.4394C3.81884 11.3501 3.80092 11.2442 3.80426 11.1296C3.91769 7.24301 7.59917 2.88064 13.0291 2.88064Z",
    stroke: "#CA9D97",
    strokeWidth: 0.164592
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2182_51293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2909 6.52998C21.368 8.13351 19.8075 9.80298 17.8758 9.80298H8.12538C6.19372 9.80298 4.62595 8.13449 5.6881 6.52106C7.05068 4.45126 9.63991 2.79834 12.9466 2.79834C16.258 2.79834 18.8979 4.45601 20.2909 6.52998Z",
    fill: "#FFFFFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2182_51293",
    x: 2.07567,
    y: 1.15242,
    width: 22.0301,
    height: 14.5362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.822959,
    result: "effect1_foregroundBlur_2182_51293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2182_51293",
    x: 0.825517,
    y: 11.9169,
    width: 25.371,
    height: 12.3585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.822959,
    result: "effect1_foregroundBlur_2182_51293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2182_51293",
    x: 2.39448,
    y: 18.4591,
    width: 20.6684,
    height: 6.62761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164592,
    result: "effect1_foregroundBlur_2182_51293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2182_51293",
    x: 7.55911,
    y: 5.36761,
    width: 11.0368,
    height: 10.1566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.740663,
    result: "effect1_foregroundBlur_2182_51293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2182_51293",
    x: 2.65174,
    y: 1.72849,
    width: 20.8779,
    height: 13.384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.534923,
    result: "effect1_foregroundBlur_2182_51293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2182_51293",
    x: 3.69881,
    y: 1.15242,
    width: 18.5903,
    height: 10.2965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.822959,
    result: "effect1_foregroundBlur_2182_51293"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearl);
export default __webpack_public_path__ + "static/media/pearl.72b35bc4b0ce27217db33f8eeffad7e3.svg";
export { ForwardRef as ReactComponent };